var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoTip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "42px",
    viewBox: "0 0 42 42",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: 2.1,
    transform: "translate(-1798.000000, -151.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(1798.000000, 151.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-5",
    fill: "#00386E",
    cx: 20.8333333,
    cy: 20.8333333,
    r: 20.8333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-9",
    fill: "#FFFFFF",
    x: 18.75,
    y: 16.6666667,
    width: 4.16666667,
    height: 14.5833333,
    rx: 2.08333333
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-9-Copy",
    fill: "#FFFFFF",
    x: 18.75,
    y: 10.4166667,
    width: 4.16666667,
    height: 4.16666667,
    rx: 2.08333333
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoTip);
export default __webpack_public_path__ + "static/media/infoTip.7fb9d1a2256db387ee1ce6a142dc5c40.svg";
export { ForwardRef as ReactComponent };